module.exports = __webpack_public_path__ + "media/images/Icon-card-coworking-72a0e15b6b9c6b32c52efffa5b66fb05.svg";